// src/components/Layout/Navbar.tsx
import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { ArrowLeftIcon } from '@heroicons/react/24/outline';

export const Navbar: React.FC = () => {
    const navigate = useNavigate();
    const location = useLocation();

    // Страницы, где нужно скрыть навбар
    const hiddenPaths = [
        '/product/',
        '/category/',
        '/delivery-selection',
        '/checkout',
        '/payment',
        '/'
    ];

    // Проверяем, нужно ли скрыть навбар
    const hideNavbar = hiddenPaths.some(path => location.pathname.startsWith(path));

    // Показываем кнопку назад не на главной странице и не на странице продуктов
    const showBackButton = !hideNavbar && location.pathname !== '/' && location.pathname !== '/products';

    // Получаем заголовок страницы
    const getTitle = () => {
        if (location.pathname === '/') return 'Ruyo Market';
        if (location.pathname === '/products') return 'Товары';
        if (location.pathname === '/cart') return 'Корзина';
        if (location.pathname === '/profile') return 'Профиль';
        if (location.pathname === '/login') return 'Вход';        // 👈 ИЗМЕНЕНО
        if (location.pathname === '/register') return 'Регистрация'; // 👈 ДОБАВЛЕНО
        if (location.pathname.startsWith('/product/')) return 'Товар';
        if (location.pathname.startsWith('/category/')) return 'Категории';
        if (location.pathname === '/delivery-selection') return 'Выбор доставки';
        if (location.pathname === '/checkout') return 'Оформление заказа';
        if (location.pathname === '/wishlist') return 'Избранное';     // 👈 ДОБАВЛЕНО
        if (location.pathname === '/orders') return 'Мои заказы';       // 👈 ДОБАВЛЕНО
        return 'Ruyo Market';
    };

    if (hideNavbar) {
        return null;
    }

    return (
        <nav className="navbar-mobile">
            <div className="navbar-mobile-content">
                {showBackButton ? (
                    <button onClick={() => navigate(-1)} className="back-button-mobile">
                        <ArrowLeftIcon style={{ width: 24, height: 24 }} />
                    </button>
                ) : (
                    <div style={{ width: 40 }} />
                )}

                <h1 className="logo-mobile">{getTitle()}</h1>

                <div style={{ width: 40 }} />
            </div>
        </nav>
    );
};